import { primaryImageStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

primaryImageStyles.primaryImage = {
    img: {
        css: css`
            cursor: zoom-in;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        max-height: 300px !important;
                    `,
                    css`
                        max-height: 300px !important;
                    `,
                ])}
        `,
    },
};

primaryImageStyles.primaryImage = {
    centeringWrapper: {
        css: css`
            max-width: 450px;
            min-height: 300px;
            margin: 10px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                height: auto;
                max-width: 100%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`
                            max-height: 300px !important;
                        `,
                        css`
                            max-height: 300px !important;
                        `,
                    ])}
            }
        `,
    },
};
